export const ROOT_NODE_ID = 'root';
export const NODE_ID_SEPARATOR = '[&]';
export const ROOT_BEGINNING_REGEX = /^root\[&\]*/;
export const DATA_CELL_ID_SEPARATOR = '-';
